import { render, staticRenderFns } from "./ShortDetailsSection.vue?vue&type=template&id=8c6a58ca&scoped=true"
import script from "./ShortDetailsSection.vue?vue&type=script&lang=js"
export * from "./ShortDetailsSection.vue?vue&type=script&lang=js"
import style0 from "./ShortDetailsSection.vue?vue&type=style&index=0&id=8c6a58ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6a58ca",
  null
  
)

export default component.exports